import React, { FC } from "react";
import { useParams } from "react-router-dom";

import {
  useApisManagersSalesConceptCategoriesEdit,
  useProvidersCurrentEmployee,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";
import { SalesConceptCategoryWithSalesConceptsForm } from "~/components/organisms";
import { NotFoundIndex } from "~/components/pages";

export const ManagersSalesConceptCategoriesEdit: FC = () => {
  const { id = "" } = useParams<{ id: string }>();
  const { currentEmployee } = useProvidersCurrentEmployee();

  const { data: fetchEditData, isError } =
    useApisManagersSalesConceptCategoriesEdit({
      id,
    });

  const breadCrumbItems = [
    { label: "ブログ", href: "/managers/sales_concept_categories" },
    { label: "編集", href: `/managers/sales_concept_categories/${id}/edit` },
  ];

  if (isError) {
    return <NotFoundIndex />;
  }

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent withRightSidebar>
        {currentEmployee && fetchEditData && (
          <SalesConceptCategoryWithSalesConceptsForm
            currentEmployee={currentEmployee}
            salesConceptCategory={fetchEditData.salesConceptCategory}
            selectableSalesConceptTags={
              fetchEditData.selectableSalesConceptTags
            }
          />
        )}
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar />
    </EmployeeLayout>
  );
};
